import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import news from '../../assets/img/news/news1.jpg'
import FooterSection from '../Footer'
import ConnectUs from '../../components/ConnectUs'
import Calendar from 'react-calendar'
import Header from '../Header'
import 'react-calendar/dist/Calendar.css'
import { mn } from 'date-fns/locale'
import { services } from '../../assets/dummy'

export default function Booking () {
  const [isScrolled, setIsScrolled] = useState(false)
  const [value, onChange] = useState(new Date())
  const [selectedTime, setSelectedTime] = useState(null)

  // List of time slots
  const timeSlots = [
    '10:00',
    '10:15',
    '10:30',
    '10:45',
    '11:00',
    '11:15',
    '11:30',
    '11:45',
    '12:00',
    '12:15',
    '12:30',
    '12:45',
    '13:00',
    '13:15',
    '13:30',
    '13:45',
    '14:00',
    '14:15',
    '14:30',
    '14:45',
    '15:00'
  ]

  // Reserved time slots
  const reservedSlots = ['10:30', '11:15', '12:00']

  const handleTimeSelect = time => {
    setSelectedTime(time)
  }

  return (
    <>
      <Helmet>
        <title>CellClinic - Banking and Therapy</title>
        <meta name='description' content='Cellbank' />
      </Helmet>

      <div className='self-stretch bg-white'>
        <div
          className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full z-50 transition-all duration-300 ${
            isScrolled
              ? 'bg-blue shadow-md h-[7vh] top-1 max-w-[1440px] extraScreen:max-w-[1500px]'
              : 'bg-transparent h-[5vh]'
          }`}
        >
          <Header
            color={isScrolled ? 'black' : '#235998'}
            gradientColor={isScrolled ? 'bg-white/90' : 'bg-white'}
          />
        </div>

        <div className='maxScreen:max-w-[1440px] extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto p-10 mobile:p-0'>
          <main className='flex flex-col items-center mobile:p-1'>
            {/* Centered Title */}
            <div className='flex flex-row gap-[300px] mt-20 justify-center items-center w-fit'>
              <span className='text-[14px] font-semibold border p-2 rounded-lg bg-white'>
                Эсийн банк
              </span>
              <span className='text-[14px] font-semibold border p-2 rounded-lg bg-white'>
                Өдөр сонгох
              </span>
              <span className='text-[14px] font-semibold border p-2 rounded-lg bg-white'>
                Цаг сонгох
              </span>
            </div>

            {/* Centered Grid */}
            <div className='grid grid-cols-3 gap-5 mb-10 mobile:grid-cols-1 tablet:grid-cols-2 mt-5 justify-center mx-auto w-fit  bg-[#F7F8FC] rounded-xl'>
              <div className='flex flex-col justify-start items-center  border-r-2'>
                <div className='flex flex-col justify-center items-center'>
                  <div className='h-[128px] w-[128px] mt-4'>
                    <img
                      src={services[0].content.photo}
                      alt='Cellbank'
                      className='mt-4 w-full'
                    />
                  </div>
                  <span className='text-[22px] text-[#215998]'>
                    {services[0].name}
                  </span>
                  <p className='w-[280px] text-[#626578] text-justify mt-4'>
                    {services[0].desc}
                  </p>
                  <button className='bg-[#215998] h-[48px] rounded-xl text-white p-2 mt-5'>
                    Үйлчилгээтэй танилцах
                  </button>
                </div>
              </div>

              <div className='flex flex-col justify-start items-center'>
                <div className='mt-4 bg-[#F7F8FC]'>
                  <Calendar
                    onChange={onChange}
                    value={value}
                    locale={mn}
                    className='react-calendar-custom'
                  />
                </div>
              </div>

              <div className='flex flex-col justify-center items-center  border-l-2'>
                <div className='mt-4 bg-[#F7F8FC]'>
                  <div className='flex flex-row justify-start items-center mb-4'>
                    <div className='flex flex-row justify-start items-center'>
                      <div className='bg-white border h-[24px] w-[24px] rounded-xl ml-2'></div>
                      <span className='ml-2 mr-4 text-[12px]'>Сул цаг</span>
                    </div>
                    <div className='flex flex-row justify-start items-center'>
                      <div className='bg-gray-400 h-[24px] w-[24px] rounded-xl'></div>
                      <span className='ml-2 text-[12px]'>Захиалагдсан</span>
                    </div>
                  </div>

                  <div className='grid grid-cols-4 gap-4'>
                    {timeSlots.map(time => (
                      <button
                        key={time}
                        onClick={() => handleTimeSelect(time)}
                        className={`p-2 border rounded-xl h-10 ${
                          reservedSlots.includes(time)
                            ? 'bg-gray-400 text-white cursor-not-allowed'
                            : selectedTime === time
                            ? 'bg-blue-500 text-white'
                            : 'bg-white border-gray-300'
                        }`}
                        disabled={reservedSlots.includes(time)}
                      >
                        {time}
                      </button>
                    ))}
                  </div>

                  {selectedTime && (
                    <div className='py-4 text-lg'>
                      <strong>Selected Time: </strong>
                      {selectedTime}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </main>

          <div className='mt-10 mobile:px-5 mobile:mt-5'>
            <ConnectUs bgImage='blue' />
            <FooterSection />
          </div>
        </div>
      </div>
    </>
  )
}
